import { DateTimePicker, DateTimePickerProps } from "@mui/x-date-pickers";
import { CustomTextField } from "./CustomTextField";
import { ChevronDownIcon } from "./Icons";

export const CustomDateTimePicker = (props: DateTimePickerProps) => {
  return (
    <DateTimePicker enableAccessibleFieldDOMStructure={false} ampm={false} slots={{ textField: CustomTextField, openPickerIcon: ChevronDownIcon }} {...props} />
  );
};
